import { useLayoutData } from "../layout/myCoursesLayoutLoader.ts";
import useProgramDecision from "./useProgramDecision.tsx";
import { ProgramDecision } from "../../../../common/api/decimal/methods/course.ts";

export default function useProgramName(forDecision?: ProgramDecision) {
  const { config } = useLayoutData();
  const programDecision = useProgramDecision();
  const decision = forDecision ?? programDecision;
  return (decision && config[decision]?.programName) ?? "";
}
